import styled from '@emotion/styled';
import { Loading as LoadingComponent } from '@presentation/components';

export const MapMarkerLoading = styled(LoadingComponent)`
  width: 32px;
  height: 32px;
  margin: 0 10px;
  filter: invert(88%) sepia(9%) saturate(5159%) hue-rotate(160deg) brightness(93%) contrast(96%);
`;
